import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");

// La page peut contenir du HTML pré-rendu (SEO). On le conserve pour Google
// et les premiers instants d'affichage, puis on repart d'un rendu client
// propre pour éviter toute erreur d'hydratation (animations déjà terminées
// dans le HTML capturé vs état initial attendu par React).
if (rootElement.hasChildNodes()) {
  rootElement.innerHTML = "";
}

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
